// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__eVcs_","placeholder":"Navbar_placeholder__PaS1g","loading":"Navbar_loading__czpv8","show":"Navbar_show__wn0TF"};